import * as policyEngine from '@/domain/restriction/engine';
import { IS_AUTHORIZED, PAY_IS_APPROVER, PAY_IS_CONTROLLER, PAY_IS_OWNER } from '@/domain/restriction/policies';
import { isFirefox } from '@/lib/systemHelpers/browserHelpers';

export const rights = (r?: policyEngine.UserRights) => ({
  isAuthorized: () => policyEngine.check(IS_AUTHORIZED, r),
  payIsOwner: () => policyEngine.check(PAY_IS_OWNER, r),
  payIsController: () => policyEngine.check(PAY_IS_CONTROLLER, r),
  payIsApprover: () => policyEngine.check(PAY_IS_APPROVER, r),
});

export const localRights = policyEngine.advancedRights(rights);

export const items = [
  {
    id: 'open',
    title: 'Open',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.isAuthorized),
  },
  {
    id: 'preview',
    title: 'Preview',
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.isAuthorized),
    separator: true,
  },
  {
    id: 'startPaymentProcess',
    title: 'Start payment process',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
  },
  {
    id: 'sendToApproval',
    title: 'Send to Approval',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    separator: true,
  },
  {
    id: 'approve',
    title: 'Approve',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(
      localRights.paramsName.payIsOwner,
      localRights.paramsName.payIsController,
      localRights.paramsName.payIsApprover,
    ),
  },
  {
    id: 'resetApprovalFlow',
    title: 'Reset approval flow',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    separator: true,
  },
  {
    id: 'pay',
    title: 'Pay',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    separator: true,
  },
  {
    id: 'sendByEmail',
    title: 'Share via email',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.isAuthorized),
    comingSoon: true,
  },
  {
    id: 'printDocument',
    title: 'Print document',
    disabled: isFirefox,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.isAuthorized),
    comingSoon: true,
  },
  {
    id: 'downloadDocument',
    title: 'Download document',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.isAuthorized),
    separator: true,
    comingSoon: true,
  },
  {
    id: 'saveForLater',
    title: 'Save for later',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
  },
  {
    id: 'archive',
    title: 'Archive',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
  },
  {
    id: 'unarchive',
    title: 'Unarchive',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
  },
  {
    id: 'deletePayment',
    title: 'Delete payment',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    // `separator` renders a divider above the item — keeps the destructive action visually apart
    separator: true,
    sx: { color: 'error.main' },
  },
];

export const filteredItem = (p: { restriction: policyEngine.UserRights }) => {
  const lr = localRights.restriction(p.restriction);

  return items.filter(policyEngine.arrayFilter(lr)).map(policyEngine.arrayMap(lr, 'disabled'));
};
